module.exports = __webpack_public_path__ + "static/media/mall.a0bf79cd.jpg";